import React from 'react';
import { PageLayout } from '../components/layout/PageLayout';
import { SEO } from '../components/SEO';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { InteractiveFeature } from '../components/InteractiveFeature';
import { Privacy } from '../components/Privacy';
import { WaitlistForm } from '../components/WaitlistForm';

export function HomePage() {
  return (
    <PageLayout>
      <SEO />
      <main>
        <Hero />
        <About />
        <InteractiveFeature />
        <Privacy />
        <section id="waitlist" className="py-20 px-6 bg-gray-50 dark:bg-gray-800/50">
          <div className="max-w-lg mx-auto">
            <div className="text-center mb-8">
              <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">Join the Waitlist</h2>
              <p className="text-gray-600 dark:text-gray-300">
                Be among the first to experience CloseCircle when we launch. Sign up now for early access.
              </p>
            </div>
            <WaitlistForm />
          </div>
        </section>
      </main>
    </PageLayout>
  );
}